"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringify = void 0;
const convertType = (obj) => {
    if (obj === null) {
        return { t: 'null' };
    }
    if (obj === undefined) {
        return { t: 'undefined' };
    }
    if (obj instanceof Date) {
        return { t: 'Date', v: obj.toISOString() };
    }
    switch (typeof obj) {
        case 'string':
            return { t: 'string', v: obj };
        case 'number':
            return { t: 'number', v: obj.toString() };
        case 'boolean':
            return { t: 'boolean', v: obj ? '1' : '0' };
        case 'bigint':
            return { t: 'bigint', v: obj.toString() };
    }
    throw new Error(`Unknown datatype: ${typeof obj}`);
};
const decent = (obj, customStringify) => {
    if (customStringify) {
        const tmpObj = customStringify(obj);
        if (tmpObj !== undefined) {
            return tmpObj;
        }
    }
    if (Array.isArray(obj)) {
        return obj.map((obj) => decent(obj, customStringify));
    }
    else if (obj && typeof obj === 'object' && !(obj instanceof Date)) {
        const tmpObj = {};
        for (const [key, value] of Object.entries(obj)) {
            tmpObj[key] = decent(value, customStringify);
        }
        return tmpObj;
    }
    return convertType(obj);
};
const stringify = (obj, customStringify) => {
    return JSON.stringify(decent(obj, customStringify));
};
exports.stringify = stringify;
